var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p1-container"},[(_vm.isBrain1)?_c('div',{attrs:{"id":"brain-pie1"}}):_vm._e(),(_vm.isBrain2)?_c('div',{attrs:{"id":"brain-pie2"}}):_vm._e(),(_vm.isBrain3)?_c('div',{attrs:{"id":"brain-pie3"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }